package diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp

/**
 * Cap content to [max] and center it horizontally so screens don't sprawl edge-to-edge on wide/desktop
 * web. Reliable regardless of the parent's alignment: it fills the available width, relaxes the min so
 * the child can be narrower, centers it, then caps the max.
 *
 * IMPORTANT: `Modifier.fillMaxWidth().widthIn(max = X)` does NOT cap — `fillMaxWidth` pins the width to
 * the parent and the later `widthIn` is a no-op. That ordering bug is exactly why some screens stretched
 * full-width despite "having" a cap. Use this helper instead.
 */
fun Modifier.appContentWidth(max: Dp): Modifier =
    this.fillMaxWidth().wrapContentWidth(Alignment.CenterHorizontally).widthIn(max = max)
